module.exports = __webpack_public_path__ + "img/loading.672d9634.svg";